export default __webpack_public_path__ + "static/media/awc-icon.fe8531ac.webp";